import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import PageHero from './components/PageHero';
import CompanyInfo from './components/CompanyInfo';
import AccessInfo from './components/AccessInfo';

export default function CompanyPage() {
  useSEO({
    title: '法人概要 | まごころヘルパー - 会社情報・アクセス【逗子市訪問介護】',
    description: '逗子市の訪問介護事業者まごころヘルパーの法人概要。株式会社Noyの事業として、平成31年3月1日設立。代表取締役 野家美樹、資本金300万円。事業所は逗子5-7-17、JR東逗子駅徒歩7分、京急逗子葉山駅徒歩2分。法令遵守・コンプライアンス体制も整備しています。',
    keywords: '法人概要,会社情報,逗子市,まごころヘルパー,訪問介護事業者,アクセス,コンプライアンス',
    path: '/company',
    schema: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "株式会社Noy まごころヘルパー",
      "description": "逗子市で訪問介護サービスを提供する株式会社Noyの事業",
      "foundingDate": "2019-03-01",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "逗子5-7-17 コーポ高木101",
        "addressLocality": "逗子市",
        "addressRegion": "神奈川県",
        "postalCode": "249-0006",
        "addressCountry": "JP"
      },
      "telephone": "+81-46-876-6471",
      "url": `${import.meta.env.VITE_SITE_URL}/company`,
      "founder": {
        "@type": "Person",
        "name": "野家美樹"
      }
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.observe-animation').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PageHero />
      <CompanyInfo />
      <AccessInfo />
    </div>
  );
}
